// 간단한 암호화/복호화 유틸리티
// 실제 프로덕션에서는 더 강력한 암호화 사용 권장

export const encryptData = (data) => {
  try {
    // JSON을 문자열로 변환
    const jsonString = JSON.stringify(data);
    
    // Base64 인코딩
    const base64 = btoa(unescape(encodeURIComponent(jsonString)));
    
    // URL-safe하게 변환
    return base64
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const decryptData = (encryptedString) => {
  try {
    // URL-safe 문자를 원래대로 복원
    let base64 = encryptedString
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    
    // 패딩 추가
    while (base64.length % 4) {
      base64 += '=';
    }
    
    // Base64 디코딩
    const jsonString = decodeURIComponent(escape(atob(base64)));
    
    // JSON 파싱
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// URL 생성 헬퍼
export const generateDocumentUrl = (data) => {
  const encrypted = encryptData(data);
  if (!encrypted) return null;
  
  const baseUrl = window.location.origin;
  return `${baseUrl}/document?payload=${encrypted}`;
};

// 사용 예시:
/*
// 데이터 암호화하여 URL 생성
const documentData = {
  orderId: '123456789',
  documentType: 'both',
  signedBy: 'Eric Lee',
  invoiceDate: '2025-01-31',
  contractNumber: 'BVC-2025-Q1-001',
  carrier: 'DHL',
  prepaid: true,
  remarks: 'Handle with care',
  sailingDate: '2025-02-15'
};

const url = generateDocumentUrl(documentData);
console.log('Document URL:', url);

// URL에서 데이터 복호화
const urlParams = new URLSearchParams(window.location.search);
const encryptedPayload = urlParams.get('payload');
const decryptedData = decryptData(encryptedPayload);
console.log('Decrypted data:', decryptedData);
*/